module.exports = __webpack_public_path__ + "static/first_close-fa715a78588dbefd7482037e6b400a5c.png";